import React, { useState, useEffect } from 'react';
import { Button, Typography, Autocomplete, TextField } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate, useParams } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import * as Constants from '../Constants';
import '../App.css';

const SiteAdmin = () => {
  const [sites, setSites] = useState([]);
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [site, setSite] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();
  let { id } = useParams();

  useEffect(() => {
    const onFetchSuccess = (user) => {
      setLastName(user.last);
      setFirstName(user.first);
      setEmail(user.email);
      setPhone(user.phone);
      setSite(user._site);
    };

    const fetchUser = async (id) => {
      const params = {
        _id: id,
      };
      rpc({
        method: 'GetUser',
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onFetchSuccess
      });
    };

    const getSites = async () => {
      rpc({
        method: 'GetSites',
        params : {},
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: setSites
      });
    };

    getSites();
    if (id) {
      fetchUser(id);
    }
  }, [id]);


  const onSuccess = () => {
    navigate('/siteAdmins');
  };

  const createUser = async () => {
    if (lastName === '' || firstName === '' || email === '' || password === '' || site === null) {
      setErrorMessage('All fields are required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      last: lastName,
      first: firstName,
      password,
      email,
      phone,
      _site: site,
      roles: [Constants.ROLE_COMMUNITY_ADMIN],
    };
    rpc({
      method: 'CreateUser',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const updateUser = async () => {
    if (lastName === '' || firstName === '' || email === '' || site === null) {
      setErrorMessage('All fields except Password are required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      _id: id,
      last: lastName,
      first: firstName,
      email,
      phone,
      _site: site,
    };
    if (password !== '') {
      params.password = password;
    }
    rpc({
      method: 'UpdateUser',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const getButtons = () => {
    if (id) {
      return (
        <>
          <Button className="Button" variant="contained" color="primary" onClick={updateUser}>
          Update
          </Button>
        </>
      );
    } return (
      <>
        <Button className="Button" variant="contained" color="primary" onClick={createUser}>
        Create
        </Button>
      </>
    );
  };

  return (
    <div className="SiteAdminDetails">
      <Typography variant="h6" gutterBottom>
        Admin User Details
      </Typography>
      <TextField className="TextField"
        label="Email"
        value={email}
        size="small"
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField className="TextField"
        label="Password"
        type="password"
        value={password}
        size="small"
        onChange={(e) => setPassword(e.target.value)}
      />
      <TextField className="TextField"
        label="Phone"
        value={phone}
        size="small"
        onChange={(e) => setPhone(e.target.value)}
      />
      <TextField className="TextField"
        label="Last Name"
        value={lastName}
        size="small"
        onChange={(e) => setLastName(e.target.value)}
      />
      <TextField className="TextField"
        label="First Name"
        value={firstName}
        size="small"
        onChange={(e) => setFirstName(e.target.value)}
      />
      <Autocomplete className="Autocomplete"
        value={site}
        isOptionEqualToValue={(site, value) => site?._id === value?._id}
        options={sites}
        onChange={(e, value) => {setSite(value);}}
        getOptionLabel={(site) => site.name}
        renderInput={(params) => <TextField {...params} label="Site" variant="outlined" size="small"/>}
      />
      {getButtons()}
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default SiteAdmin;
